import { css } from 'emotion'

export const spacers = {
  '1': '0.25rem',
  '2': '0.5rem',
  '3': '1rem',
  '4': '2rem',
  '5': '3.5rem',
  '6': '4rem',
  '7': '6rem',
  '8': '10rem',
}

export const spaced = css`
  margin: ${spacers['7']} 0;
`
